import { Above, Below } from '@jetshop/ui/Breakpoints';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import { SortOrders } from './SortOrders';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import React, { Component } from 'react';
import { ActiveFilters } from './ActiveFilters';
import { BooleanFilters } from './BooleanFilters';
import FilterDrawer from './FilterDrawer';
import { ListFilters } from './ListFilters';
import { MultiListFilters } from './MultiListFilters';
import { RangeFilters } from './RangeFilters';
import FilterButton from './Mobile/FilterButton';
import { theme } from '../../Theme';

const Filters = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: ${theme.space[1]};

  > div {
    width: max-content;
    margin-right: 16px;
    position: relative;
  }

  [data-flight-dropdown-items] {
    position: absolute;
  }
`;

const FiltersSectionWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;

const FiltersWapper = styled('div')`
  width: 100%;
`;
const BoolSortWrapper = styled('div')`
  /* min-width: 224px; */
  display: flex;
  flex-direction: row;

  font-size: 0.875rem;
  > div {
    /* width: 224px; */

    margin-bottom: 1em;
    button {
      height: 40px;
      background-color: #f7f7f7;
    }
  }
  .boolean-wrapper {
    direction: rtl;
    display: flex;
    > label {
      margin-bottom: 6px;
      margin-right: ${theme.space[2]};
      span {
        margin: 0 0 0 8px;

        svg {
          path {
            fill: ${theme.colors.black};
          }
        }
      }
    }
  }

  [data-flight-dropdown-items] {
    right: 0;
    left: auto;
  }
  [data-flight-dropdown-item] {
    display: flex;
    * + * {
      margin-left: auto;
    }
  }
`;

const sortOrderButtonCSS = css`
  margin-right: 0 !important;
  > div {
    height: 42px;
    min-width: 180px;
    font-size: 1rem;
  }
`;

class Filter extends Component {
  render() {
    const { filters } = this.props;
    const sortOrders = this.props?.sortOrders ?? [];

    return (
      <>
        <Above breakpoint="md">
          {matches =>
            matches && (
              <>
                <FiltersSectionWrapper>
                  <FiltersWapper>
                    <Filters>
                      <div className={sortOrderButtonCSS}>
                        <SortOrders sortOrders={sortOrders} />
                      </div>
                      <ListFilters filters={filters} />
                      <RangeFilters filters={filters} />
                      <MultiListFilters filters={filters} />
                    </Filters>
                  </FiltersWapper>
                  <BoolSortWrapper>
                    <div className="boolean-wrapper">
                      <BooleanFilters filters={filters} />
                    </div>
                  </BoolSortWrapper>
                </FiltersSectionWrapper>
                <div className="active-filter-wrapper">
                  <ActiveFilters filters={filters} />
                </div>
              </>
            )
          }
        </Above>
        <Below breakpoint="md">
          {matches =>
            matches && (
              <>
                <DrawerTrigger id="filterDrawer">
                  {({ showTarget }) => (
                    <FilterButton showTarget={showTarget} filters={filters} />
                  )}
                </DrawerTrigger>

                <DrawerTarget id="filterDrawer">
                  {({ hideTarget, isOpen }) => (
                    <Drawer isOpen={isOpen} right>
                      <FilterDrawer
                        close={hideTarget}
                        filters={filters}
                        sortOrders={sortOrders}
                      />
                    </Drawer>
                  )}
                </DrawerTarget>
              </>
            )
          }
        </Below>
      </>
    );
  }
}

export default Filter;
